export default class TabModel {
  constructor(id, index, label, ariaControl, disabled = false, indexHidden = null) {
    this.id = id;
    this.index = index;
    this.label = label;
    this.ariaControl = ariaControl;
    this.disabled = disabled;
    this.indexHidden = indexHidden;
  }
}
